import { FlatList, Pressable, StyleSheet } from "react-native";
import Box from "../Box";
import { GridCard } from "../OnboardingApplet/GridCard";

export type CategoryItem = {
	id: string;
	title: string;
	image: React.ReactNode;
};

type Props = {
	items: CategoryItem[];
	selectedId?: string;
	onSelect: (id: string) => void;
};

const CategoryGrid = ({ items, selectedId, onSelect }: Props) => {
	return (
		<FlatList
			data={items}
			numColumns={2}
			keyExtractor={(item) => item.id}
			contentContainerStyle={styles.container}
			columnWrapperStyle={styles.columnWrapper}
			renderItem={({ item }) => (
				<Pressable onPress={() => onSelect(item.id)} style={styles.item}>
					<Box style={{ aspectRatio: 1, width: "100%" }}>
						<GridCard
							title={item.title}
							type="selectable"
							isSelected={selectedId === item.id}
							gap={16}
						>
							{item.image}
						</GridCard>
					</Box>
				</Pressable>
			)}
		/>
	);
};

const styles = StyleSheet.create({
	container: {
		paddingHorizontal: 16,
		paddingBottom: 16,
	},
	columnWrapper: {
		gap: 16,
		marginBottom: 16,
	},
	item: {
		flexBasis: "48%",
		maxWidth: "48%",
		flexGrow: 0,
	},
});

export default CategoryGrid;
